import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/zh2';
export const locale = {
  lang: 'zh2',
  data: {
    'CONSULTA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': '諮詢調查',
      'SUBTITULO': '查詢平台在特定時期內產生的調查信息',
      'CAMPOS': {
        'anio': '年',
        'broker': '經紀人',
        'brokerCountry': '經紀人國家',
        'anioRanking': '年份排名',
      },
      'RESULTADOS': {
        'CARGANDO': '加載搜索結果',
        'TITULO': '結果',
        'ENCONTRADAS': '找到的調查總數',
        'DESCARGAR': '以 Excel 格式下載信息',
        'SINRESULTADOS': '未找到使用指定參數創建的調查'
      }
    }
  }
};
